module.exports = __webpack_public_path__ + "static/media/EmaildownBtn.8084cf59.svg";